import type { Control, UseFormReset, UseFormSetValue } from 'react-hook-form';
import { EndorsementPremiumChange } from '@domain/schemas/endorsement-premium-change';
import type { CreateEndorsementSpaPayload } from '@domain/schemas/payload.schema';

export type EndorsementFormState = Partial<CreateEndorsementSpaPayload> & {
  parentSubmissionId?: string;
};

export interface StepProps {
  control: Control<EndorsementFormState>;
  formValues: EndorsementFormState;
  isReadOnly?: boolean;
  reset?: UseFormReset<EndorsementFormState>;
  setValue?: UseFormSetValue<EndorsementFormState>;
}

export enum EndorsementStep {
  ParentSelection = 0, // Standalone only
  SummaryTemplate = 1, // Endorsement Source: blank template or duplicate an existing endorsement
  EndorsementSelection = 2, // Duplicate path only
  BasicInfo = 3,
  ReasonPremium = 4,
}

export const isConditionalPremiumOption = (premium_change?: EndorsementPremiumChange) =>
  Boolean(
    premium_change && [EndorsementPremiumChange.ADDITION, EndorsementPremiumChange.RETURN].includes(premium_change),
  );
